import React from 'react';
import Styled from 'styled';
import { Query } from '@apollo/client/react/components';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import LoadingProgress from 'lib/react-router/loading-progress';
import SVGIconView from 'lib/images/svg-icon-view';

import { displayedName } from 'four-nets/user/utils';
import ErrorPage from 'four-nets/errors/error-page';
import RightArrow from 'four-nets/icons/svg/icon_arrow-right.svg';
import { AlbumFragment } from 'four-nets/photoblog/posts/album/album.graphql';

import query, { UserAlbumsQuery, UserAlbumsQueryVariables } from './author-albums.graphql';
import AuthorAlbum from './author-album/author-album';
import defaultStyles from './author-albums.scss';

export interface Props {
    user: NonNullable<AlbumFragment['user']>;
    albumSlug: string;
    styles: typeof defaultStyles;
}

class AuthorAlbums extends React.PureComponent<Props> {
    render() {
        const { styles, user, albumSlug } = this.props;

        const userBlogLink =
            user.profile && user.profile.isVendor
                ? `/catalog/vendor/${user && user.username}`
                : `/blog/${user && user.username}`;

        const gender = (user.profile && user.profile.sex) || 2;

        return (
            <Query<UserAlbumsQuery, UserAlbumsQueryVariables>
                query={query}
                variables={{
                    username: user.username,
                    excludeSlug: albumSlug,
                }}
                fetchPolicy='cache-first'
            >
                {({ loading, data, error }) => (
                    <LoadingProgress loading={loading}>
                        <ErrorPage error={error}>
                            {data && data.userAlbums && data.userAlbums.edges && data.userAlbums.edges.length > 0 ? (
                                <div className={styles.wrapper}>
                                    <FormattedMessage
                                        id='MORE_ALBUMS_BY_USER'
                                        values={{ gender: gender === 1 ? 'f' : 'm', username: displayedName(user) }}
                                    >
                                        {msg => <p className={styles.title}>{msg}</p>}
                                    </FormattedMessage>
                                    <ul className={styles.albums}>
                                        {data.userAlbums.edges.map(edge =>
                                            edge && edge.node && edge.node.slug !== albumSlug ? (
                                                <li key={edge.node.id} className={styles.album}>
                                                    <AuthorAlbum {...edge} />
                                                </li>
                                            ) : null
                                        )}
                                    </ul>
                                    {data.userAlbums.pageInfo.hasNextPage ? (
                                        <Link to={`${userBlogLink}/?post_type=POST_ALBUM`} className={styles.link}>
                                            <div className={styles.linkDiv}>
                                                <FormattedMessage id='SHOW_EVERYTHING'>
                                                    {msg => <span className={styles.linkText}>{msg}</span>}
                                                </FormattedMessage>
                                                <SVGIconView className={styles.linkImage} src={RightArrow} />
                                            </div>
                                        </Link>
                                    ) : null}
                                </div>
                            ) : null}
                        </ErrorPage>
                    </LoadingProgress>
                )}
            </Query>
        );
    }
}

export default Styled(defaultStyles)(AuthorAlbums);
